import { Button, Icon } from "semantic-ui-react";

import { useCan, useSelectedLocation } from "components";
import { ACL_ACTIVITIES, ACL_RESOURCES } from "models";
import { ChecklistItem } from "modules/ChecklistsDashboard/components/ChecklistsList/components";
import { useReorderChecklistMutation } from "modules/ChecklistsDashboard/components/ChecklistsList/components/LocationChecklistItem/hooks";

import type { Checklist, ChecklistID } from "models";
import type { MouseEvent } from "react";

type LocationChecklistItemProps = {
  checklist: Checklist;
  isFirst: boolean;
  isLast: boolean;
  onClick: (checklistID: ChecklistID) => void;
};

export const LocationChecklistItem = ({ checklist, isFirst, isLast, onClick }: LocationChecklistItemProps) => {
  const { selectedLocation } = useSelectedLocation();
  const { mutate: reorderChecklist, isPending } = useReorderChecklistMutation();

  const canReorder = useCan(ACL_ACTIVITIES.Update, ACL_RESOURCES.Checklists);

  const displayOrder = checklist.display_order ?? 0;

  const handleReorder = (event: MouseEvent, newDisplayOrder: number) => {
    event.stopPropagation();
    if (!selectedLocation) return;

    reorderChecklist({ checklist_id: checklist.id, location_id: selectedLocation.id, display_order: newDisplayOrder });
  };

  return (
    <ChecklistItem checklist={checklist} onClick={() => onClick(checklist.id)}>
      {canReorder && (
        <>
          {!isLast && (
            <Button className="-appointment-status icon" size="small" disabled={isPending} onClick={event => handleReorder(event, displayOrder + 1)}>
              <Icon className="chevron down" color="black" />
            </Button>
          )}

          {!isFirst && (
            <Button className="-appointment-status icon" size="small" disabled={isPending} onClick={event => handleReorder(event, displayOrder - 1)}>
              <Icon className="chevron up" color="black" />
            </Button>
          )}
        </>
      )}
    </ChecklistItem>
  );
};
